const padNumber = (digits: number) => (x: number) => {
    const right = x.toString(10);

    return right.length >= digits ? right : `${Array.from(Array(digits - right.length)).map(_ => '0').join('')}${right}`;
};

export const utcDateFrom = (createdOn: string) => new Date(createdOn.endsWith('Z') ? createdOn : `${createdOn}Z`);
export const displayUtcDate = (createdOn: string) => {
    const utcDate = new Date(utcDateFrom(createdOn));
    const padDate = padNumber(2);

    return `${padDate(utcDate.getMonth() + 1)}/${padDate(utcDate.getDate())}/${utcDate.getFullYear()}`;
};

export const inDays = (date: Date) => (x: number) => new Date(date.setDate(date.getDate() + x));

export const daysAgo = (x: number) => inDays(new Date())(-x);
